module.exports = __webpack_public_path__ + "static/messages_pozemni_hokej-ff5593a1ecbf0406090c717332e55c14.mp4";